import { createContext, useContext } from 'react';
import type { User } from '@radevents/shared';

/**
 * Das angemeldete Konto, ohne die Abhängigkeiten von `AuthContext` (Axios, Services). Für
 * Bausteine, die überall eingebunden werden, auch in Tests und im Design-Lab ohne Provider, etwa
 * die Anzeigen im Werbeplatz. `null` = nicht angemeldet. Gesetzt von `AuthProvider`.
 */
export const SignedInUserContext = createContext<User | null>(null);

export const useSignedInUser = (): User | null => useContext(SignedInUserContext);
